import io from "socket.io-client";
const isLocal = window.location.hostname === "localhost";

const socketURL = isLocal
  ? "http://localhost:9000"
  : "https://whatami-backend.herokuapp.com";

export default io(socketURL);
